<template>
<b-sidebar
    id="cat-form-sidebar"
    :visible="isAmenityFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(amenityData)"
    @hidden="resetForm(resetData)"
    @change="(val) => $emit('update:is-amenity-form-sidebar-active', val)"
>
    <template #default="{ hide }">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
            <h5 class="mb-0">
                Amenity Form
            </h5>
    
            <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="hide"
            />
        </div>
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
            <b-form
                class="p-2"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
            >
                <b-tabs content-class="mt-1" v-if="langs.length > 0">
                    <b-tab v-for="(lang,key) in langs" :key="'tab-'+key"  :title="lang.name">
                        <validation-provider
                            #default="validationContext"
                            :name="'title_'+lang.code"
                            rules="min:0"
                        >
                            <b-form-group
                                label="Title"
                                :label-for="'title_'+lang.code"
                            >
                                <b-form-input
                                    :id="'title_'+lang.code"
                                    v-model="Data.title[lang.code]"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    :placeholder="'Title ('+lang.code+')'"
                                    @input="changeTitle(lang.code)"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="validationContext"
                            :name="'slug' + lang.code"
                            rules="required"
                        >
                            <b-form-group
                                label="Slug"
                                :label-for="'slug' + lang.code"
                            >
                                <b-form-input
                                    :id="'slug' + lang.code"
                                    v-model="Data.slug[lang.code]"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    :placeholder="'Slug (' + lang.code + ')'"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-tab>
                </b-tabs>
                <div class="border rounded p-2">
                    <h4 class="mb-1">Icon Image</h4>
                    <b-media
                      no-body
                      vertical-align="center"
                      class="flex-column flex-md-row"
                    >
                      <b-media-aside>
                        <b-img
                          ref="refPreviewEl"
                          :src="Data.icon?Data.icon:require(`@/assets/images/no-image.png`)"
                          height="75"
                          width="75"
                          class="rounded mr-2 mb-1 mb-md-0"
                        />
                      </b-media-aside>
                      <b-media-body>
                        <small class="text-muted"
                          >Recommend image resolution 75x75.</small
                        >
                        <b-card-text class="my-50"> </b-card-text>
                        <div class="d-inline-block">
                          <b-form-file
                            ref="refInputEl"
                            v-model="Data.iconFile"
                            accept=".jpg, .png, .gif,.webp,"
                            placeholder="Choose file"
                            @input="inputImageRenderer"
                          />
                        </div>
                        <b-card-text class="my-50">
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            v-if="Data.icon"
                            @click="revomeImage"
                            >Remove Image</b-button
                          >
                        </b-card-text>
                      </b-media-body>
                    </b-media>
                  </div>
                  <br/>
                <validation-provider
                    #default="validationContext"
                    name="IsActive"
                    rules="required"
                >
                    <b-form-group label="Is Active" label-for="IsActive">
                        <b-form-checkbox
                            id="isactive"
                            checked="true"
                            class="custom-control-success"
                            v-model="Data.is_active"
                            switch
                        />
                        <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
                <div class="d-flex mt-2">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-success"
                      class="mr-2"
                      type="submit"
                    >
                      Save
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      type="button"
                      variant="outline-danger"
                      @click="hide"
                    >
                      Cancel
                    </b-button>
                </div>
            </b-form>
        </validation-observer>
    </template>
</b-sidebar>
</template>

<script>
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton, BTabs,
    BTab, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { required, alphaNum, email, password,confirmed } from '@validations'
import Ripple from 'vue-ripple-directive'
import { ref,onUnmounted } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import languagesStoreModule from '@/views/languages/languagesStoreModule'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import store from '@/store'
import { slugify } from '@/@fake-db/utils'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback,
        BButton, vSelect, BTabs, BTab, ValidationProvider, ValidationObserver, BCard,
        BAvatar, BLink, BMedia, BMediaAside, BMediaBody, BImg, BCardText, BFormFile,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: 'isAmenityFormSidebarActive',
        event: 'update:is-amenity-form-sidebar-active',
    },
    props: {
        isAmenityFormSidebarActive: {
            type: Boolean,
            required: true,
        },
        amenityData: {
            type: Object,
            required: false,
        },
    },
    setup(props, { emit }) {
        const {  appRef } = $themeConfig.app
        const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
        });
        const tabIndex = ref(0);
        const toast = useToast();
        const userStorage = JSON.parse(localStorage.getItem('userData'));
        const getLocalSite = JSON.parse(localStorage.getItem('site'))
        const langs = ref([]);
        const blankData = {
            title: {},
            slug: {},
            is_active: true,
            ordering_count: 0,
            sites_id: getLocalSite.id,
            created_by: userStorage.id,
        }
        const Data = ref(blankData)

        const resetData = () => {
            Data.value = blankData
        }

        const changeTitle  = (lang) => {
            if(lang){
                Data.value.slug[lang] = slugify(Data.value.title[lang]);
            }
        }

        const getData = (amenityData) => {
            tabIndex.value = 0;
            
            if(amenityData) {
                amenityData.is_active = amenityData.is_active? true: false
                Data.value = amenityData
            } else {
                Data.value = blankData
                Data.value.title = {}
                Data.value.slug = {}
                Data.value.iconFile = null
                refPreviewEl.value.src = require('@/assets/images/no-image.png');
            }
        }

        const onSubmit = async function ()  {
            const formData = new FormData();

            Data.value.is_active = Data.value.is_active?1:0;
            
            formData.append('iconFile', refInputEl.value.files[0])
            formData.append('data', JSON.stringify(Data.value))

            if(!Data.value.id){
                store.dispatch('app-room/addAmenity',{
                    data: Data.value,
                    formData: formData
                })
                .then((res) => {
                    toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'BellIcon',
                            variant: 'success',
                            text: `${res.data.message}`,
                        },
                    });
                    
                    emit('refetch-data')
                    emit('update:is-amenity-form-sidebar-active', false)
                })
                .catch((error) => {
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: "Error fetching Destination' list",
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            text: error.response.data.message,
                        },
                    })
                })
            } else {
                store.dispatch('app-room/updateAmenity', {
                    data: Data.value,
                    formData: formData
                }).then((res) => {
                    toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'BellIcon',
                            variant: 'success',
                            text: `${res.data.message}`,
                        },
                    });

                    emit('refetch-data')
                    emit('update:is-amenity-form-sidebar-active', false)
                })
                .catch((error) => {
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: "Error fetching Destination' list",
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            text: error.response.data.message,
                        },
                    })
                })
            }
            
        }

        const getLangs = (filter)=>{
            store.dispatch('app-languages/fetchData', filter)
                .then((res) => {
                    if(res.data.success){
                        langs.value = res.data.data;
                    }  
            });
        }

        let filter = {
            is_active:1,
        }

        getLangs(filter);

        const refeshList = async () => {
            emit("refetch-data");
        };

        const {
            refFormObserver,
            getValidationState,
            resetForm
        } = formValidation(resetData)

        const refInputEl = ref(null);
        const refPreviewEl = ref(null);
        const { inputImageRenderer } = useInputImageRenderer(
            refInputEl,
            (base64) => {
                refPreviewEl.value.src = base64;
            }
        );
        const revomeImage = () => {
            Data.value.icon = '';
        };

        return {
            langs,
            resetData,
            getValidationState,
            Data,
            resetForm,
            refFormObserver,
            changeTitle,
            getData,
            onSubmit,
            refeshList,
            inputImageRenderer,
            tabIndex,
            refInputEl,
            refPreviewEl,
            revomeImage
        }
    }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
</style>